import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'economicAmount',
  standalone: true,
})
export class EconomicAmountPipe implements PipeTransform {
  transform(value: string | number | null | undefined): string {
    if (value === null || value === undefined || value === '') {
      return '-';
    }

    const stringValue = value.toString();
    const parts = stringValue.split(',');
    let integerPart = parts[0];
    const decimalPart = parts[1] || '';

    integerPart = integerPart.replace(/\./g, '');
    const numValue = parseFloat(integerPart + (decimalPart ? '.' + decimalPart : ''));
    if (isNaN(numValue)) {
      return '-';
    }

    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    let result = formattedInteger;
    if (decimalPart) {
      result += ',' + decimalPart;
    }
    result += ' €';

    return result;
  }
}
